import type { REDIRECT_PAGE } from '@/shared/redirect/constants';
import { omitNullish } from '@/shared/utils/omit-nullish';

type LoginSearchOverrides = {
  redirectPage?: REDIRECT_PAGE;
  token?: string;
};

export function buildLoginSearch(searchStr: string, overrides: LoginSearchOverrides = {}) {
  const currentSearch = Object.fromEntries(new URLSearchParams(searchStr));

  return {
    ...currentSearch,
    ...omitNullish(overrides),
  };
}
